<template>
  <v-stepper-items>
    <v-stepper-content class="pa-0" step="5">
      <v-alert
        v-model="errorMsgAlert"
        close-text="Close Alert"
        class="alert-text my-5 mx-3"
        color="error"
        dark
        dismissible
        ref="snackbarError"
        style="color: white !important"
      >
        {{ $t(errorMsg) }}
      </v-alert>

      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6" xl="6">
          <v-container class="py-0">
            <v-card class="card py-5 my-3">
              <h3 class="text-center mb-3" translate>
                {{ $t(["PAYMENT INFORMATION"]) }}
              </h3>

              <v-divider class="mx-3"></v-divider>

              <v-alert
                v-show="store.formSubmissionData.errorMessage != null"
                close-text="Close Alert"
                class="alert-text my-3 mx-3"
                color="error"
                dark
                dismissible
                style="color: white !important"
              >
                {{ $t(store.formSubmissionData.errorMessage) }}
              </v-alert>

              <v-col v-if="submitDigitalPayment" col="12" align="center">
                <p>
                  <b>{{
                    $t("Processing, please do not refresh your browser")
                  }}</b>
                </p>

                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-col>

              <div v-show="!submitDigitalPayment">
                <v-form ref="paymentInfoForm">
                  <v-row class="my-0 py-0 px-5 mt-3">
                    <v-col class="py-0" cols="6">
                      <!-- <div
                      placeholder="{{ 'Cardholder Name' | translate }}"
                    ></div> -->
                      <v-text-field
                        :label="$t(['CardholderName_Label'])"
                        class="error-field"
                        v-model.trim="cardName"
                        :rules="rules.cardName"
                      ></v-text-field>
                    </v-col>

                    <v-col class="py-0" cols="6">
                      <!-- <div
                      placeholder="{{ 'Billing Postal Code' | translate }}"
                    ></div> -->
                      <v-text-field
                        :label="$t(['BillingPostalCode_Label'])"
                        class="error-field"
                        v-model="billingPostalCode"
                        v-mask="'A#A #A#'"
                        :rules="rules.postalCode"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- <div placeholder="{{ 'Card Number' | translate }}"></div> -->
                  <v-text-field
                    :label="$t(['CardNumber_Label'])"
                    class="error-field px-5"
                    v-model="cardNumber"
                    v-mask="
                      cardType == 'AMEX'
                        ? '#### ###### #####'
                        : '#### #### #### ####'
                    "
                    :maxlength="cardType == 'AMEX' ? 19 : 20"
                    :error="cardNumberError"
                    :error-messages="cardNumberErrorMessage"
                    :rules="rules.cardNumber"
                  >
                    <template v-slot:append>
                      <v-icon
                        v-show="cardType == 'Visa' && cardNumber.length > 0"
                        class="mr-5"
                      >
                        $vuetify.icons.cardVisa
                      </v-icon>

                      <v-icon
                        v-show="
                          cardType == 'Mastercard' && cardNumber.length > 0
                        "
                        class="mr-5"
                      >
                        $vuetify.icons.cardMastercard
                      </v-icon>

                      <v-icon
                        v-show="cardType == 'AMEX' && cardNumber.length > 0"
                        class="mr-5"
                      >
                        $vuetify.icons.cardAmericanExpress
                      </v-icon>

                      <v-icon
                        v-show="cardType == 'Discover' && cardNumber.length > 0"
                        class="mr-5"
                      >
                        $vuetify.icons.cardDiscover
                      </v-icon>
                    </template>
                  </v-text-field>

                  <v-row class="my-0 py-0 px-5 mb-3">
                    <v-col class="py-0" cols="7">
                      <!-- <div
                      placeholder="{{ 'Expiry Date (MM/YY)' | translate }}"
                    ></div> -->
                      <v-text-field
                        :label="$t(['Expiry Date'])"
                        class="error-field"
                        v-model="cardExpiry"
                        v-mask="'##/##'"
                        maxlength="5"
                        :rules="rules.cardExpiry"
                      ></v-text-field>
                    </v-col>

                    <v-col class="py-0" cols="5">
                      <!-- <div placeholder="{{ 'CVV' | translate }}"></div> -->
                      <!-- CVV REQUIRED -->
                      <v-text-field
                        :label="$t(['CVV'])"
                        class="error-field"
                        v-model="cardCVV"
                        v-mask="'####'"
                        maxlength="4"
                        :rules="rules.cardCVV"
                      ></v-text-field>

                      <!-- CVV NOT REQUIRED -->
                      <!-- <v-text-field
                      :label="$t(['CVV'])"
                      class="error-field"
                      v-model="cardCVV"
                      v-mask="'####'"
                      maxlength="4"
                    ></v-text-field> -->
                    </v-col>
                  </v-row>
                </v-form>

                <!-- DIGITAL WALLETS (APPLE PAY & GOOGLE PAY) -->
                <div class="px-5">
                  <v-row
                    v-if="showGooglePayBtn || showApplePayBtn"
                    align="center"
                  >
                    <v-col cols="5">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="2" class="text-center">
                      <span>{{ $t(["OR"]) }}</span>
                    </v-col>
                    <v-col cols="5">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>

                  <div v-show="showGooglePayBtn" class="google-pay my-3">
                    <div id="googlePayBtn" />
                  </div>

                  <div v-show="showApplePayBtn">
                    <apple-pay-button
                      id="applePayBtn"
                      buttonstyle="black"
                      type="plain"
                      locale="en"
                      :class="showGooglePayBtn ? 'mb-3' : 'my-3'"
                      @click="applePayButtonClicked"
                    ></apple-pay-button>
                  </div>
                </div>

                <v-divider class="mx-3"></v-divider>

                <v-row class="mt-3">
                  <v-col cols="6" align="center">
                    <v-btn class="btn-text" large @click="previousStep()">
                      {{ $t(["Back"]) }}
                    </v-btn>
                  </v-col>

                  <v-col cols="6" align="center">
                    <v-btn
                      class="btn-text"
                      color="primary"
                      large
                      @click="nextStep()"
                    >
                      {{ $t(["Next"]) }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-container>
        </v-col>
      </v-row>
    </v-stepper-content>
  </v-stepper-items>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { useFormDataStore } from "../../../store/formData.js";
import loadGooglePayScript from "@/utils/googlePay.js";

export default {
  name: "S5_PaymentInfo",
  data: () => {
    return {
      billingPostalCode: "",
      cardName: "",
      cardNumber: "",
      cardExpiry: "",
      cardCVV: "",
      cardType: "",
      cardNumberError: false,
      cardNumberErrorMessage: "",
      rules: {
        postalCode: [],
        cardName: [],
        cardNumber: [],
        cardExpiry: [],
        cardCVV: [],
      },
      showGooglePayBtn: false,
      showApplePayBtn: false,
      submitDigitalPayment: false,
      errorMsgAlert: false,
      errorMsg: "",
    };
  },
  setup() {
    const store = useFormDataStore();

    return {
      store,
    };
  },
  props: {
    postalCode: String,
  },
  watch: {
    "store.orderInfo.merchTotal"() {
      this.updateDigitalWalletVisibility();
    },
    "store.donationInfoFormData.donationAmount"() {
      this.updateDigitalWalletVisibility();
    },
    "$i18n.locale"() {
      this.$refs.paymentInfoForm.resetValidation();
    },
    postalCode() {
      this.billingPostalCode = this.postalCode;
    },
    billingPostalCode() {
      this.billingPostalCode = this.billingPostalCode.toUpperCase();
    },
    cardNumber(input) {
      if (input != "") {
        if (input.substring(0, 1) == "4") {
          this.cardType = "Visa";
        } else if (input.substring(0, 1) == "5") {
          this.cardType = "Mastercard";
        } else if (input.substring(0, 1) == "6") {
          this.cardType = "Discover";
        } else if (
          input.substring(0, 2) == "34" ||
          input.substring(0, 2) == "37"
        ) {
          this.cardType = "AMEX";
        } else {
          this.cardType = "";
        }
      }

      this.cardNumberError = false;
      this.cardNumberErrorMessage = "";
    },
    cardType() {
      if (this.rules.cardNumber.length > 0) {
        this.rules.cardNumber =
          this.cardType == "AMEX"
            ? [
                (v) => !!v || "Required",
                (v) => (v || "").length >= 17 || "Invalid card number",
              ]
            : [
                (v) => !!v || "Required",
                (v) => (v || "").length >= 19 || "Invalid card number",
              ];
      }
    },
  },
  async created() {
    try {
      await loadGooglePayScript();

      this.initializeGPay();
    } catch (error) {
      console.error("Google Pay script load error:" + error);
    }

    try {
      await this.loadScript(
        "https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js",
      );
    } catch (error) {
      console.error("Apple Pay SDK load error:" + error);
    }

    this.updateDigitalWalletVisibility();
  },
  methods: {
    getTotalAmount() {
      let total =
        (this.store.orderInfo.merchTotal || 0) +
        (this.store.donationInfoFormData.donationAmount || 0);

      return total.toFixed(2);
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = () => resolve(script);
        script.onerror = () =>
          reject(new Error(`Script load error for ${src}`));
        document.head.appendChild(script);
      });
    },
    initializeGPay() {
      const googlePayConfiguration = {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: "CARD",
            tokenizationSpecification: {
              type: "PAYMENT_GATEWAY",
              parameters: {
                gateway: process.env.VUE_APP_GATEWAY,
                gatewayMerchantId: process.env.VUE_APP_GATEWAY_MERCHANT_ID,
              },
            },
            parameters: {
              allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
              allowedCardNetworks: ["MASTERCARD", "VISA", "AMEX"],
            },
          },
        ],
      };

      let paymentsClient;

      const addGooglePayButton = () => {
        const googlePayButton = paymentsClient.createButton({
          onClick: onGooglePaymentButtonClicked,
          buttonSizeMode: "fill",
          buttonRadius: 5,
          buttonType: "pay",
        });

        if (document.getElementById("googlePayBtn")) {
          document.getElementById("googlePayBtn").appendChild(googlePayButton);
        }
      };

      const onGooglePaymentButtonClicked = () => {
        this.store.aPayToken = null;
        this.store.aPaySession = null;

        const paymentDataRequest = Object.assign({}, googlePayConfiguration, {
          allowedPaymentMethods: [
            {
              ...googlePayConfiguration.allowedPaymentMethods[0],
              tokenizationSpecification: {
                type: "PAYMENT_GATEWAY",
                parameters: {
                  gateway: process.env.VUE_APP_GATEWAY,
                  gatewayMerchantId: process.env.VUE_APP_GATEWAY_MERCHANT_ID,
                },
              },
            },
          ],
          merchantInfo: {
            merchantId: process.env.VUE_APP_GOOGLE_PAY_MERCHANT_ID,
            merchantName: "Terry Fox Foundation",
          },
          callbackIntents: ["PAYMENT_AUTHORIZATION"],
          transactionInfo: {
            countryCode: "CA",
            currencyCode: "CAD",
            totalPriceStatus: "FINAL",
            totalPrice: this.getTotalAmount(),
            totalPriceLabel: "Total",
          },
        });

        paymentsClient
          .loadPaymentData(paymentDataRequest)
          .then((paymentData) => {
            return paymentData;
          })
          .catch((error) => console.error("loadPaymentData error: ", error));
      };

      paymentsClient = new window.google.payments.api.PaymentsClient({
        environment:
          process.env.NODE_ENV == "production" ? "PRODUCTION" : "TEST",
        paymentDataCallbacks: {
          onPaymentAuthorized: this.onPaymentAuthorized,
        },
      });

      paymentsClient
        .isReadyToPay(googlePayConfiguration)
        .then((response) => {
          if (response.result) {
            addGooglePayButton();
          }
        })
        .catch((error) => console.error("isReadyToPay error: ", error));
    },
    async onPaymentAuthorized(paymentData) {
      const token = paymentData.paymentMethodData.tokenizationData?.token;
      let approved = false;

      // Charge first, then close the Google Pay sheet with the real result
      if (token) {
        this.store.gPayToken = token;
        approved = await this.processDigitalPayment();
      }

      if (approved) {
        return { transactionState: "SUCCESS" };
      }

      return {
        transactionState: "ERROR",
        error: {
          intent: "PAYMENT_AUTHORIZATION",
          reason: "PAYMENT_DATA_INVALID",
          message: this.$t([
            "An error occurred while processing your payment. Please try again.",
          ]),
        },
      };
    },
    applePayButtonClicked() {
      this.store.gPayToken = null;

      const paymentRequest = {
        countryCode: "CA",
        currencyCode: "CAD",
        total: {
          label: "Terry Fox Foundation",
          amount: this.getTotalAmount(),
        },
        supportedNetworks: ["amex", "masterCard", "visa"],
        merchantCapabilities: ["supports3DS"],
        requiredBillingContactFields: ["postalAddress"],
      };

      const session = new window.ApplePaySession(6, paymentRequest);

      session.oncancel = () => {
        this.store.aPaySession = null;
        this.store.aPayToken = null;
      };

      session.onvalidatemerchant = async (event) => {
        try {
          const requestData = {
            displayName: "Terry Fox Foundation",
            domain: window.location.hostname || "terryfox.pllenty.com",
            validationUrl: event.validationURL,
            sandbox: process.env.NODE_ENV !== "production",
          };

          const response = await fetch(
            "https://api.pllenty.com/new-forms/apay/session/tff",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestData),
            },
          ).then((res) => {
            if (!res.ok) {
              throw new Error(
                "Error validating merchant session: " + res.status,
              );
            }

            return res.json();
          });

          const merchantSession = JSON.parse(response.session_details);

          session.completeMerchantValidation(merchantSession);
        } catch (error) {
          console.error("onvalidatemerchant error:", error);

          session.abort();
        }
      };

      session.onpaymentauthorized = async (event) => {
        this.store.aPaySession = session;
        this.store.aPayToken = event.payment.token;

        // Charge first, then close the Apple Pay sheet with the real result
        const approved = await this.processDigitalPayment();

        session.completePayment({
          status: approved
            ? window.ApplePaySession.STATUS_SUCCESS
            : window.ApplePaySession.STATUS_FAILURE,
        });
      };

      session.begin();
    },
    updateDigitalWalletVisibility() {
      const totalAmount = Number(this.getTotalAmount());

      this.showGooglePayBtn =
        !!(window.google && window.google.payments?.api) && totalAmount > 0;

      let canMakeApplePayments = false;

      try {
        canMakeApplePayments = !!window.ApplePaySession?.canMakePayments();
      } catch (error) {
        // canMakePayments() throws on insecure (non-HTTPS) pages
      }

      this.showApplePayBtn = canMakeApplePayments && totalAmount > 0;
    },
    setFieldValidationRules() {
      this.rules.postalCode = [
        (v) => !!v || this.$t(["Required"]),
        (v) => (v || "").length >= 7 || this.$t(["Invalid postal code"]),
      ];
      this.rules.cardName = [(v) => !!v.trim() || this.$t(["Required"])];
      this.rules.cardNumber =
        this.cardType == "AMEX"
          ? [
              (v) => !!v || this.$t(["Required"]),
              (v) =>
                (v || "").length >= 17 ||
                this.$gettext(this.$t(["Invalid card number"])),
            ]
          : [
              (v) => !!v || this.$t(["Required"]),
              (v) => (v || "").length >= 19 || this.$t(["Invalid card number"]),
            ];
      this.rules.cardExpiry = [
        (v) => !!v || this.$t(["Required"]),
        (v) =>
          (v || "").length >= 5 ||
          this.$gettext(this.$t(["Invalid expiry date"])),
      ];
      this.rules.cardCVV = [
        (v) => !!v || this.$t(["Required"]),
        (v) => (v || "").length >= 3 || this.$gettext(this.$t(["Invalid CVV"])),
      ];
    },
    async nextStep() {
      await this.setFieldValidationRules();

      if (this.$refs.paymentInfoForm.validate()) {
        // Check if card number entered is either Visa, Mastercard AMEX or Discover
        if (this.cardType == "") {
          this.cardNumberError = true;
          this.cardNumberErrorMessage = this.$t(["Invalid card number"]);

          this.rules.cardNumber = [];

          return;
        }

        this.store.setPaymentInfoFormData({
          postalCode: this.billingPostalCode,
          cardHolder: this.cardName.trim(),
          cardNumber: this.cardNumber.replace(/\s/g, ""),
          cardExpiry: this.cardExpiry,
          expiryMonth: this.cardExpiry.split("/")[0],
          expiryYear: "20" + this.cardExpiry.split("/")[1],
          cvv: this.cardCVV,
        });

        this.$emit("nextStepFromFive");
      } else {
        // Scroll to first error
        this.$nextTick(() => {
          const el = this.$el.querySelector(
            ".v-messages.error--text:first-of-type",
          );
          this.$vuetify.goTo(-5, el);

          return;
        });
      }
    },
    previousStep() {
      this.$emit("previousStepFromFive");
    },
    // Submits the wallet token to the backend; resolves true if approved
    async processDigitalPayment() {
      let approved = false;

      try {
        this.submitDigitalPayment = true;

        let formData =
          this.getTotalAmount() > 0
            ? {
                ...this.store.donationInfoFormData,
                ...this.store.registrationInfoFormData,
                ...this.store.paymentInfoFormData,
                amount: this.getTotalAmount(),
              }
            : this.store.orderInfo.type == "RegisterAndDonate" &&
              this.store.orderInfo.selection.includes("Donation")
            ? {
                ...this.store.donationInfoFormData,
                amount: this.getTotalAmount(),
              }
            : {
                ...this.store.donationInfoFormData,
                ...this.store.registrationInfoFormData,
                amount: this.getTotalAmount(),
              };

        if (this.store.gPayToken !== null) {
          formData = {
            ...formData,
            gPayToken: this.store.gPayToken,
          };
        } else if (this.store.aPayToken !== null) {
          formData = {
            ...formData,
            aPayToken: this.store.aPayToken,
          };
        }

        await axios
          .post(process.env.VUE_APP_BASE_URL_API + "form/process", {
            eventName: this.store.eventName,
            runSiteId: this.store.orderInfo.runSiteId,
            orderId: this.store.orderInfo.id,
            formData,
            dt: moment(new Date(Date.now())).format(),
          })
          .then((response) => {
            // console.log(response);

            this.store.setFormSubmissionData({
              status: response.data.status,
              merchantId: response.data.merchantId,
              errorMessage:
                response.data.message != undefined
                  ? response.data.message
                  : null,
              total: this.getTotalAmount(),
            });

            approved = response.data.status == "Approved";

            this.$emit("formSubmittedDigitalPayment");
          });
      } catch (error) {
        this.errorMsgAlert = true;
        this.errorMsg = error.message;

        this.$nextTick(() => {
          const el = this.$el.querySelector("snackbarError");
          this.$vuetify.goTo(-5, el);

          return;
        });
      }

      this.submitDigitalPayment = false;

      return approved;
    },
  },
};
</script>

<style lang="scss" scoped>
apple-pay-button {
  --apple-pay-button-width: 100%;
  --apple-pay-button-height: 39px;
  --apple-pay-button-border-radius: 5px;
  --apple-pay-button-padding: 0px;
  --apple-pay-button-box-sizing: border-box;
  display: inline-block;
}
</style>
